// extracted by mini-css-extract-plugin
module.exports = {"main":"TermsOfUse_main__lo7i-"};